<template>
  <div v-if="!loading" class="d-flex flex-column align-items-center gap-3">
    <p class="fw-bold fs-5 ps-0 mb-0">
      Please attach all PDF documents related to the case.
    </p>

    <file-upload
      @files-ready="onFilesReady"
      @files-not-ready="onFilesNotReady"
    />

    <p class="fw-bold fs-5 ps-0 mb-0">
      Once all documents have been uploaded, click "Start Processing".
    </p>

    <button
      class="btn btn-primary fw-bold align-self-center"
      :disabled="!filesReady"
      @click="startProcessing"
    >
      Start Processing
    </button>
  </div>

  <loading-spinner v-else />

  <div v-if="error" class="text-start fw-bold mb-4 mt-2 text-danger">
    {{ error }}
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import FileUpload from '@/components/FileUpload.vue';
import { processFiles } from '@/common/api';
import LoadingSpinner from '@/components/LoadingSpinner.vue';
import errorHandlerMixin from '@/mixins/errorHandlerMixin';
import { UploadedFile } from '@/types/UploadedFile';

export default defineComponent({
  name: 'StartProcessing',

  components: { LoadingSpinner, FileUpload },

  mixins: [errorHandlerMixin],

  props: {
    sessionId: {
      type: Number,
      required: true,
    },
    handleFetchSessionInfo: {
      type: Function,
      required: true,
    },
  },

  data() {
    return {
      filesReady: false,
      uploadedFiles: [] as UploadedFile[],
      loading: false,
    };
  },

  methods: {
    startProcessing() {
      const fileIds = this.uploadedFiles
        .map((file) => file.id)
        .filter((id): id is number => id !== null);

      this.loading = true;

      processFiles(this.sessionId, fileIds)
        .then(() => {
          this.handleFetchSessionInfo();
        })
        .catch((error) => {
          this.handleError(error, 'Error starting processing: ');
          this.loading = false;
        });
    },

    onFilesNotReady() {
      this.filesReady = false;
      this.uploadedFiles = [];
    },

    onFilesReady(files: UploadedFile[]) {
      this.filesReady = true;
      this.uploadedFiles = files;
    },
  },
});
</script>
